var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.country)?_c('div',{staticClass:"user-location"},[(!_vm.hideFlag)?_c('div',{staticClass:"user-location-country"}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.country))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }